
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inquiry",
      function () {
        return require("private-next-pages/inquiry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inquiry"])
      });
    }
  